import React, { useState } from "react";
import cx from "classnames";

import useValidations from "../../../utils/useValidations";
import useForceValidate from "../../../utils/useForceValidate";
import useAppContext from "../../AppContext";

import ErrorSwitch from "../../ErrorSwitch";

import styles from "./styles.module.scss";

export default function Textarea({
  id,
  name,
  onChange: broadcastChange,
  value: defaultValue,
  rules,
  disabled = false,
  placeholder = "",
  withAutofocus = true,
  className
}) {
  const [value, setValue] = useState(() => defaultValue);
  const { newQuiz, forceValidation } = useAppContext();
  const [isValid, validations, validate] = useValidations(rules.validators);

  const { hasTriggered } = useForceValidate({
    trigger: forceValidation,
    validate: () => validate(value || "")
  });

  const onChange = ev => {
    let { name: key, value } = ev.target;
    setValue(value);
    value = validate(value)[0] ? value : null;
    broadcastChange(key, value);
  };

  const renderError = newQuiz.isSequence
    ? hasTriggered && !disabled
    : !disabled;

  return (
    <>
      <textarea
        id={id}
        name={name}
        onChange={onChange}
        className={cx(styles.textarea, {
          [styles.error]: !isValid,
          [styles.disabled]: disabled,
          [className]: className
        })}
        placeholder={placeholder}
        disabled={disabled}
        autoFocus={withAutofocus}
        value={value ?? ""}
      />
      {renderError && (
        <ErrorSwitch name={`textarea-${id}-form`} validations={validations}>
          {rules.errorMessages}
        </ErrorSwitch>
      )}
    </>
  );
}
